import ErrorBoundary from '@office-start/error-boundary';
import React from 'react';
var LazyMeControlComponentInternal = React.lazy(function () {
    return import(
    /* webpackChunkName: "me-control-component"  */ '@office-start/me-control');
});
/**
 * @todo This is a placeholder for a AppBarButtonError fallback render that would make use of the error
 * component context to show correlationId and sessionId and a nice error message
 * @returns a PageError fallback render
 */
var AppBarButtonError = function () {
    return null;
};
export var LazyMeControlComponent = function () {
    return (React.createElement(ErrorBoundary, { fallbackRender: AppBarButtonError, errorEventName: "ErrorBoundaryAppBarComponent_MeControlComponent" },
        React.createElement(React.Suspense, { fallback: null },
            React.createElement(LazyMeControlComponentInternal, null))));
};
//# sourceMappingURL=LazyMeControlComponent.js.map